import "./index.css";

import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import styles from './style.module.css';
 //import IconProvider from "../IconProvider";
 //import { ARROW_DOWN_BOLD , arrowTop, ic_circle_close} from "../../../assets/index";

import { CSSTransition } from 'react-transition-group';
//import Typography from "../Typography";
import uuid from 'uuid-random';
import IconProvider from "../../design-system/lib/IconProvider";
import { arrowTop, ic_circle_close } from "../../assets";
import Typography from "../../design-system/lib/Typography";
import PhoneInput from "react-phone-input-2";
import Checkbox from "../../design-system/lib/Checkbox";


const CustomField_Boolean= ({ IconComponents , pretitle, handleIsOpen, hint, closeIcon,defvalue, noArrowIcon = false, value, checkSelected = "hybrid", onChange, clearOnClick, clearText, data, placement, text, badgeText, title, style, className, ref, setIsHover, size, icon, isSelected, isRequired, requiredText, textStyle } ) => {
    const [isOpen, setIsOpen] = useState(false);

    const [elmId, setElmId] = useState(`"elmDrop${uuid()}`);
    const [mapZindex, setMapZindex] = useState(0);

    //  useEffect(() => {
    //      setTimeout(() => {
    //         try {
    //               const element = document.getElementById('googlemapUniqeId');
    //               setMapZindex(element.style.zIndex)
    //         } catch (error) {
    //         }
    //      }, 1000);
    //     }, []);
    

    const dropdownNode  = useClickOutside(() => {
        setIsOpen(false);
    })

    const getParentWidth = React.useCallback(() => {

        let elm = document.getElementById(elmId)
        var box = elm.getBoundingClientRect();

        return box.width
        
      }, [elmId ]);

    useEffect(() => {

   try {
         if (handleIsOpen) {
             handleIsOpen(isOpen)
         }
 
 
   } catch (error) {
    
   }
    }, [isOpen]);


     

    return (
            <div id={elmId} onClick={(e) => { setIsHover(!isSelected) }} className={clsx(styles.tiny , className && className , isSelected && styles.isSelected)}
            style={style ? style : {}} >

 
            <Checkbox size="Small" state={isSelected ? "checked" : "unchecked"} className={styles.Checkbox } style={{width: !isSelected ? "10px" :"12px" , height: !isSelected ? "10px" :"12px"}} onClick={()=>{}} />

            <span style={{fontWeight:'400' , color :"rgba(72, 72, 72, 1)"}}> {hint} </span>
 
        

 

 
        </div>

         
      

    );
};

export default CustomField_Boolean;



const useClickOutside = (handler) => {
    const domNode = useRef();
    useEffect(() => {
       try {
         const eventHandler = (event) => {
             if (!domNode?.current?.contains(event.target)) {
                 handler();
             }
             // uncomment this for dropdown close on menu click
             // handler();
         }
         document.addEventListener("mousedown", eventHandler);
         return () => {
             document.removeEventListener('mousedown', eventHandler);
         }
       } catch (error) {
        
       }
    });
    return domNode;
}